// extracted by mini-css-extract-plugin
export var ctaWrapperStyle = "rsc_hb_paginated_list-module--ctaWrapperStyle--ms7e+";
export var headingStyle = "rsc_hb_paginated_list-module--headingStyle--fTm-Q";
export var marginBottomStyle = "rsc_hb_paginated_list-module--marginBottomStyle--baWUx";
export var paginationWrapper = "rsc_hb_paginated_list-module--paginationWrapper--neb25";
export var wrapperStyle = "rsc_hb_paginated_list-module--wrapperStyle--zaNH0";